import styles from './IcpFooter.module.css'

/** The deployed site's verified filing number, supplied at build time. */
export function IcpFooter() {
  const record = import.meta.env.VITE_ICP_RECORD?.trim()
  if (!record) return null

  return (
    <footer className={styles.footer}>
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
        {record}
      </a>
    </footer>
  )
}
